function Footer() {
    return (
        <div className="bg-primary p-12">
            <div className="grid grid-cols-1">
                <div className="text-center text-[#562F00] font-bold text-5xl">Contact</div>
                <div className="text-center text-[#562F00] mt-10">
                    <div><span className="font-bold">Phone: </span>(+976) 85237770</div>
                    {/* <div><span className="font-bold">Fax:</span> xxx-xxxx-xxxx</div> */}
                    <div><span className="font-bold">Email: </span>office@jaagegeenkanko.com</div>
                    <div><span className="font-bold">Address: </span>Room 707,Central Tower (City Tower), Sukhbaatar Square-2,</div>
                    <div> 8th Khoroo, Sukhbaatar District, Ulaanbaatar 14200, MONGOLIA</div>
                </div>
            </div>
        </div>
    )
}

export default Footer;